import SigliveServiceV1 from 'Service/sigliveServiceV1';

const patchUpdateGiveawayItem = async (id, payload) => {
  const { data } = await SigliveServiceV1({
    method: 'PATCH',
    url: `/briefs/giveaways${id ? `/${id}` : ''}`,
    data: payload,
  });

  return data?.data;
};

export default patchUpdateGiveawayItem;

